import React, { useState } from "react";
import axios from "axios";
import "./Dictionary.css";
import ListDetails from "./ListDetails";

export default function Dictionary(prop) {
    const [keyword, setKeyword] = useState("");
    const [result, setResult] = useState(null);

    const handleOnChange = (event) => {
        setKeyword(event.target.value);
    };
    const api = "https://api.dictionaryapi.dev/api/v2/entries/en";

    async function handleSearch() {
        try {
            const res = await axios.get(`${api}/${keyword}`);
            console.log(res, "res");
            setResult(res.data[0]);
        } catch (e) {
            console.log({ e });
        }
    }

    function clear() {
        setKeyword("");
        setResult(null);
    }
    return (
        <div className={`${prop.mode}`}>
            <div className="Dict">
                <form onSubmit={(e)=>{
                    e.preventDefault()
                    handleSearch()
                }}>
                <input
                    style={{
                        backgroundColor:
                            prop.mode === "dark" ? "grey" : "white",
                        color: prop.mode === "dark" ? "white" : "black",
                    }}
                    value={keyword}
                    onChange={handleOnChange}
                />
                <button className="button" type="submit">
                    Search
                </button>
                <button
                    className="button"
                    type="button"
                    disabled={!result}
                    onClick={clear}>
                    Clear
                </button>
                </form>

                {result && <ListDetails {...{ result }} />}
            </div>
        </div>
    );
}
